module.exports = __webpack_public_path__ + "img/copywriting1.5e500f2f.jpg";